import { render, staticRenderFns } from "./CruiseDetail.vue?vue&type=template&id=2f070885&scoped=true&"
import script from "./CruiseDetail.vue?vue&type=script&lang=js&"
export * from "./CruiseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f070885",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f070885')) {
      api.createRecord('2f070885', component.options)
    } else {
      api.reload('2f070885', component.options)
    }
    module.hot.accept("./CruiseDetail.vue?vue&type=template&id=2f070885&scoped=true&", function () {
      api.rerender('2f070885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/cruise/CruiseDetail.vue"
export default component.exports